import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ShareIcon from '@mui/icons-material/Share'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { RedirectUrls } from 'src/types/types'

const MobileNavbar = () => {
  const { t } = useTranslation('details')
  const router = useRouter()

  // Browser history is the source of truth — `router.back()` restores the
  // exact previous URL (filters + scroll). Reconstructing a parent path
  // from `router.query` is unreliable: the listing URL's third segment
  // (e.g. `monterrey-nuevo-leon`) is a city-derived slug, not a valid hood
  // enum, so a rebuilt `/[pillar]/[city]/[hood]` 404s.
  const goBack = () => {
    const hasHistory =
      typeof window !== 'undefined' && window.history.length > 1
    if (hasHistory) {
      router.back()
      return
    }
    // Fresh-tab direct landing — nothing to pop.
    router.push(RedirectUrls.Search)
  }

  const handleShare = async () => {
    if (navigator.share) {
      await navigator.share({
        url: window.location.href
      })
    }
  }

  return (
    <nav className="absolute z-10000 flex w-full items-center justify-between p-4">
      {/* Back Button */}
      <button
        onClick={goBack}
        className="flex size-10 items-center justify-center rounded-full bg-white-500/90 shadow-md backdrop-blur-sm transition-all hover:bg-white-500 hover:shadow-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"
        aria-label={t('MOBILE_NAV.BACK')}
      >
        <ArrowBackIcon sx={{ fontSize: 20 }} className="text-ink-700" />
      </button>

      {/* Right Actions */}
      <div className="flex items-center gap-2">
        {/* Share Button */}
        <button
          onClick={handleShare}
          className="flex size-10 items-center justify-center rounded-full bg-white-500/90 shadow-md backdrop-blur-sm transition-all hover:bg-white-500 hover:shadow-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"
          aria-label={t('MOBILE_NAV.SHARE')}
        >
          <ShareIcon sx={{ fontSize: 20 }} className="text-ink-700" />
        </button>
      </div>
    </nav>
  )
}

export default MobileNavbar
